export const PARTNER_TYPES = [
  'Dentist', 'Implantologist', 'Orthodontist', 'Parodontist', 'Endodontist', 'Laboratory'
]

export const CLINIC_TYPES = {
  CoE: 'Center of Excellence',
  clinic: 'Clinic',
  lab: 'Laboratory'
}

export const TREATMENT_TYPES = [
  'Treatment', 'Scan&Go'
]

export const INVOICE_STATUSES = [
  'Pending', 'Paid', 'Refused'
]